import { BackgroundCheckStatus, BackgroundCheckType } from '../types';
import {
    autoBackgroundCheckConfigStatuses,
    defaultBackgroundCheckConfigFilters,
    manualBackgroundCheckConfigStatuses,
} from './defaultBackgroundCheckStatuses';

export interface BackgroundCheckConfig {
    client: string;
    type: { [key in BackgroundCheckType]: BackgroundCheckConfigByType };
}

export type BackgroundCheckProcess = 'manual' | 'automatic';

export interface BackgroundCheckConfigByType {
    enabled: boolean;
    default: boolean;
    label: string;
    statuses: {
        status: BackgroundCheckStatus;
        label: string;
        enabled: boolean;
    }[];
    filter: {
        clear: BackgroundCheckStatus[];
        ready: BackgroundCheckStatus[];
        failed: BackgroundCheckStatus[];
        processing: BackgroundCheckStatus[];
    };
    process: BackgroundCheckProcess;
    requiresConsent: boolean;
    requiresFormValidation: boolean;
    displayOrder: number;
    triggerOtherBackgroundChecksOnSuccess: BackgroundCheckType[];
}

export const defaultBackgroundCheckConfig: BackgroundCheckConfig = {
    client: 'Juvare',
    type: {
        manual: {
            enabled: true,
            default: true,
            label: 'Manual',
            statuses: [...manualBackgroundCheckConfigStatuses],
            filter: defaultBackgroundCheckConfigFilters,
            process: 'manual',
            requiresConsent: false,
            requiresFormValidation: false,
            displayOrder: 1,
            triggerOtherBackgroundChecksOnSuccess: [],
        },
        criminalSuper: {
            enabled: false,
            default: false,
            label: 'Super Search',
            statuses: [...autoBackgroundCheckConfigStatuses],
            filter: defaultBackgroundCheckConfigFilters,
            process: 'automatic',
            requiresConsent: true,
            requiresFormValidation: true,
            displayOrder: 2,
            triggerOtherBackgroundChecksOnSuccess: [],
        },
        legacySexOffender: {
            enabled: false,
            default: false,
            label: 'Legacy Sex Offender',
            statuses: [...autoBackgroundCheckConfigStatuses],
            filter: defaultBackgroundCheckConfigFilters,
            process: 'automatic',
            requiresConsent: true,
            requiresFormValidation: true,
            displayOrder: 3,
            triggerOtherBackgroundChecksOnSuccess: [],
        },
        standard: {
            enabled: false,
            default: false,
            label: 'Standard',
            statuses: [...autoBackgroundCheckConfigStatuses],
            filter: defaultBackgroundCheckConfigFilters,
            process: 'automatic',
            requiresConsent: true,
            requiresFormValidation: true,
            displayOrder: 4,
            triggerOtherBackgroundChecksOnSuccess: [],
        },
        cori: {
            enabled: false,
            default: false,
            label: 'CORI',
            statuses: [...manualBackgroundCheckConfigStatuses].map((singleEntry) =>
                singleEntry.status === 'processingPending' && singleEntry.enabled ? { ...singleEntry, enabled: false } : singleEntry,
            ),
            filter: defaultBackgroundCheckConfigFilters,
            process: 'manual',
            requiresConsent: true,
            requiresFormValidation: true,
            displayOrder: 5,
            triggerOtherBackgroundChecksOnSuccess: ['vsos'],
        },
        vsos: {
            enabled: false,
            default: false,
            label: 'VSOS',
            statuses: [...autoBackgroundCheckConfigStatuses],
            filter: defaultBackgroundCheckConfigFilters,
            process: 'automatic',
            requiresConsent: true,
            requiresFormValidation: true,
            displayOrder: 6,
            triggerOtherBackgroundChecksOnSuccess: [],
        },
        patch: {
            enabled: false,
            default: false,
            label: 'PATCH',
            statuses: [...manualBackgroundCheckConfigStatuses],
            filter: defaultBackgroundCheckConfigFilters,
            process: 'manual',
            requiresConsent: false,
            requiresFormValidation: false,
            displayOrder: 7,
            triggerOtherBackgroundChecksOnSuccess: [],
        },
        jnet: {
            enabled: false,
            default: false,
            label: 'JNET',
            statuses: [...autoBackgroundCheckConfigStatuses],
            filter: defaultBackgroundCheckConfigFilters,
            process: 'automatic',
            requiresConsent: true,
            requiresFormValidation: true,
            displayOrder: 8,
            triggerOtherBackgroundChecksOnSuccess: [],
        },
    },
};
